import React from 'react';
import { updateObject } from 'helpers/objectHelpers';
import FormLabel from 'components/labels/FormLabel';
import FormSelect from 'components/forms/bases/FormSelect';
import SpacingPicker from 'components/forms/SpacingPicker';
import FormsySize from 'components/formsy/FormsySize'
import FormInputNumber from 'components/forms/FormInputNumber';
import OverflowSelector from 'components/forms/OverflowSelector';
import FormSize from 'components/forms/FormSize';
import Accordion from 'components/accordions/Accordion';
import isEmpty from 'lodash/isEmpty';
import FormTextAlign from 'components/forms/FormTextAlign'
import FormsySpacing from 'components/formsy/FormsySpacing'

const wrapperStyle = {
  padding: 15,
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
  marginTop: 10,
};

const wrapperStyleAccordion = {
  padding: 15,
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
};

const size = ({ width, height, minWidth, minHeight, handleChange }) => (
  <div key="size" style={wrapperStyle}>
    <FormLabel dark>Size( px )</FormLabel>
    <FormsySize
      name={'width'}
      label="Width"
      value={width}
      onChange={(val) => handleChange(val, 'width')}
    />
    <FormsySize
      name={'height'}
      label="Height"
      value={height}
      onChange={(val) => handleChange(val, 'height')}
    />
    <FormsySize
      name={'minWidth'}
      label="Minimum Width"
      value={minWidth}
      onChange={(val) => handleChange(val, 'minWidth')}
    />
    <FormsySize
      name={'minHeight'}
      label="Minimum Height"
      value={minHeight}
      onChange={(val) => handleChange(val, 'minHeight')}
    />
  </div>
);

const margin = ({ marginTop, marginBottom, marginLeft, marginRight, value, onChange }) => (
  <FormsySpacing
    key="margin"
    prefix={'margin'}
    label="Margin (default px, support 'auto' 'em' 'rem' 'pt')"
    top={marginTop}
    bottom={marginBottom}
    left={marginLeft}
    right={marginRight}
    onChange={(val) => onChange(updateObject(value, val))}
  />
);

const padding = ({ paddingTop, paddingBottom, paddingLeft, paddingRight, value, onChange }) => (
  <FormsySpacing
    key="padding"
    prefix={'padding'}
    label="Padding (default px, support 'auto' 'em' 'rem' 'pt')"
    top={paddingTop}
    bottom={paddingBottom}
    left={paddingLeft}
    right={paddingRight}
    onChange={(val) => onChange(updateObject(value, val))}
  />
);

const displayComponent = ({ handleChange, justifyContent, alignItems, flexDirection, display }) => (
  <div key="display" style={{ ...wrapperStyleAccordion }}>
    <FormLabel dark>Display</FormLabel>
    <FormSelect
      label="display mode"
      value={display}
      options={['', 'block', 'inline', 'inline-block', 'flex']}
      onChange={val => handleChange(val, 'display')}
    />
    {display === 'flex' &&
      <div>
        <FormSelect
          label="Justify content"
          value={justifyContent}
          options={['', 'center', 'flex-end', 'flex-start', 'space-around', 'space-between']}
          onChange={val => handleChange(val, 'justifyContent')}
        />
        <FormSelect
          value={alignItems}
          label="Align items"
          options={['', 'baseline', 'center', 'flex-end', 'flex-start', 'stretch']}
          onChange={val => handleChange(val, 'alignItems')}
        />
        <FormSelect
          value={flexDirection || 'initial'}
          label="Flex Direction"
          options={['initial', 'column', 'column-reverse', 'row', 'row-reverse']}
          onChange={val => handleChange(val, 'flexDirection')}
        />
      </div>
    }
  </div>
);
const overflowComponent = ({ handleChange, overflow }) => (
  <div key="overflow" style={wrapperStyleAccordion}>
    <FormLabel dark>Overflow</FormLabel>
    <OverflowSelector
      value={overflow}
      onChange={val => handleChange(val, 'overflow')}
    />
  </div>
);
const alignment = ({ handleChange, textAlign }) => (
  <div key="alignment" style={{ ...wrapperStyle }}>
    <FormLabel dark>Alignment</FormLabel>
    <FormTextAlign
      value={textAlign}
      onChange={(val) => handleChange(val, 'textAlign')}
    />
  </div>
)
const gutterComponent = ({ gutter, handleChangeContent }) => (
  <div key="gutter" style={wrapperStyle}>
    <FormLabel dark>Space between column</FormLabel>
    <FormInputNumber
      label="Gutter"
      value={gutter}
      onChange={(val) => handleChangeContent(val, 'gutter')}
    />
  </div>
)

const switchStyle = ({
  element,
  value,
  value: {
    display = '',
    justifyContent = '',
    alignItems = '',
    flexDirection = '',
    overflow = '',
    width = '',
    height = '',
    minWidth = '',
    minHeight = '',
    marginTop = '',
    marginBottom = '',
    marginLeft = '',
    marginRight = '',
    paddingTop = '',
    paddingBottom = '',
    paddingLeft = '',
    paddingRight = '',
    textAlign = '',
  },
  handleChange,
  onChange,
  valueContent: {
    gutter = '',
  },
  handleChangeContent,
}) => {
  switch (element) {
    case 'size':
      return size({ width, height, minWidth, minHeight, handleChange });
    case 'margin':
      return margin({ marginTop, marginBottom, marginLeft, marginRight, value, onChange });
    case 'padding':
      return padding({ paddingTop, paddingBottom, paddingLeft, paddingRight, value, onChange });
    case 'display':
      return displayComponent({ handleChange, justifyContent, alignItems, flexDirection, display });
    case 'overflow':
      return overflowComponent({ handleChange, overflow });
    case 'alignment':
      return alignment({ handleChange, textAlign });
    case 'gutter':
      return gutterComponent({ gutter, handleChangeContent })
    default:
      return <div> element not match in styleStructure </div>;
  }
};

const LayoutForm = ({
  value,
  onChange,
  styleStructure: {
    layout: {
      basic = {},
      advance = {},
    },
  },
  onRerender,
  valueContent = {},
  onChangeContent,
}) => {
  const handleChange = (val, key) => onChange(updateObject(value, { [key]: val }));
  const handleChangeContent = (val, key) => onChangeContent(updateObject(valueContent, { [key]: val }));
  return (
    <div>
      { !isEmpty(basic) && basic.map(item => (
        switchStyle({
          element: item,
          value,
          handleChange,
          onChange,
          valueContent,
          handleChangeContent,
        })
      ))
      }
      { !isEmpty(advance) &&
        <Accordion onTouchTab={onRerender} accordionProps={{ borderNotShow: true }}>
          <Accordion.Pane
            label="Advance"
            subValue="advance"
          >
            {advance.map((item) => (
              switchStyle({
                element: item,
                value,
                handleChange,
                onChange,
                valueContent,
                handleChangeContent,
              })
            ))
            }
          </Accordion.Pane>
        </Accordion>
      }
    </div>
  );
};

LayoutForm.propTypes = {};
LayoutForm.defaultProps = {};

export default LayoutForm;



// WEBPACK FOOTER //
// ./src/components/forms/LayoutForm.js